exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".market-modal .sweet-modal.is-alert .sweet-content{padding:0!important;text-align:left}.market-modal .sweet-modal .sweet-box-actions .sweet-action-close{color:#fff}.market-modal .sweet-modal .sweet-box-actions{top:6px}.market-modal .sweet-modal{min-width:1200px;max-width:1200px;border-radius:8px;max-height:90vh;background-color:transparent}.market-modal .sweet-content-content .content{height:calc(90vh - 62px)}", ""]);

// exports
